export const SET_LINKING_TARGET_TYPE = 'SET_LINKING_TARGET_TYPE';